<div class="cx-clear-cart-container">
  <ng-container *ngIf="!isClearing; else loading">
    <output [attr.aria-label]="'common.loaded' | cxTranslate"></output>
    <!-- Modal Header -->
    <div class="modal-header cx-clear-cart-header">
      <div class="cx-clear-cart-title modal-title">
        {{ 'clearCart.clearCart' | cxTranslate }}
      </div>

      <button
        (click)="close('Close Clear Cart Dialog')"
        [attr.aria-label]="'common.close' | cxTranslate"
        class="close"
        type="button"
      ></button>
    </div>

    <!-- Modal Body -->
    <div class="cx-clear-cart-body">
      <div class="clear-cart-msg">
        {{ 'clearCart.allItemsWillBeRemoved' | cxTranslate }}
      </div>
      <div class="clear-cart-warning" role="alert">
        {{ 'clearCart.areYouSureToClearCart' | cxTranslate }}
      </div>
      <div>
        <div class="cx-clear-cart-footer">
          <button (click)="close('Cancel Clear Cart')" class="btn btn-secondary" type="button">
            {{ 'common.cancel' | cxTranslate }}
          </button>
          <button (click)="clearCart()" class="btn btn-primary" type="button">
            {{ 'clearCart.clearCart' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <div class="modal-header cx-clear-cart-header">
    <div class="cx-clear-cart-title modal-title">
      {{ 'clearCart.clearingCart' | cxTranslate }}
    </div>
  </div>
</ng-template>